import { cx } from './cx';

const TILE = ['bg-coral-500', 'bg-sage-500', 'bg-lagoon-500', 'bg-wood-500'];

/** Stable colour per child so siblings are easy to tell apart. */
export const childTone = (childId: string) => TILE[[...childId].reduce((n, ch) => n + ch.charCodeAt(0), 0) % TILE.length]!;

export const ChildAvatar = ({ name, childId, size = 'md' }: { name: string; childId: string; size?: 'sm' | 'md' | 'lg' }) => (
  <span
    aria-hidden="true"
    className={cx(
      'inline-flex shrink-0 items-center justify-center font-display font-extrabold text-white',
      childTone(childId),
      size === 'sm' && 'h-7 w-7 rounded-[9px] text-[14px]',
      size === 'md' && 'h-9 w-9 rounded-[11px] text-[17px]',
      size === 'lg' && 'h-12 w-12 rounded-[16px] text-[22px]',
    )}
  >
    {name.trim().charAt(0).toUpperCase() || '·'}
  </span>
);

export const ChildChip = ({ name, childId, detail, className = '' }: { name: string; childId: string; detail?: string; className?: string }) => (
  <span className={cx('inline-flex items-center gap-2.5', className)}>
    <ChildAvatar name={name} childId={childId} />
    <span className="leading-tight">
      <span className="block text-label text-ink">{name}</span>
      {detail && <span className="block text-caption text-ink-muted">{detail}</span>}
    </span>
  </span>
);
